var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMenuContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.27272V21H6.27273V10.3636L7.90909 12V19.3636H19.3636V7.90908H12L10.3636 6.27272H21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14.2244V15.8608L15.8608 15.8608L15.8608 9L14.2244 9L14.2244 13.0483L4.17614 3L3 4.17614L13.0483 14.2244L9 14.2244Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuContract);
export default __webpack_public_path__ + "static/media/ic-menu-contract.796ab81e6298a14bfe8a52ed21ad02b4.svg";
export { ForwardRef as ReactComponent };